import { UrcenieGestora, UrcenieGestoraApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new UrcenieGestoraApi(apiConfiguration(elegislativaPrefixPath));

const map = (gestorUuid: Uuid, spolugestori: Array<string>): UrcenieGestora => ({
  gestorUuid,
  spolugestorList: spolugestori,
});

// eslint-disable-next-line import/prefer-default-export
export const changeGestor = async (
  type: string,
  year: number,
  index: number,
  gestorUuid: Uuid,
  spolugestori: Array<string>,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.setGestor(type, year, index, map(gestorUuid, spolugestori), headers);
  return {
    responseCode: status,
  };
};
